@for (username of usernames(); track username) {
  <p-button (click)="setUsername(username)" severity="secondary">{{
    username
  }}</p-button>
  <br />
}
<br />
<br />
<p-button (click)="generateUsername()" [raised]="true" severity="secondary">
  Genereeri suvalised nimed
</p-button>

<br />
<br />

<p-float-label>
  <input
    pInputText
    type="text"
    label="Kasutaja nimi"
    [formControl]="username" />
  <label>Sinu hüüdnimi</label>
</p-float-label>
<br />

<p-button (click)="register()" [raised]="true" severity="secondary">
  Registreeru
</p-button>
